<template>
  <!-- 消息/文案管理-站内信 -->
  <div class="system_mail-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" @click="visibleAdd = true">发送站内消息</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload accept=".xls,.xlsx" :show-file-list="false" :on-success="onSuccess" :on-error="onError"
            style="display: inline-flex; margin-right: 10px" :action="action" :headers="headers">
            <el-button size="small" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-download" @click="downloadExcel">
            下载模版
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model="query.content" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getData(1)">
            搜索
          </el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="batch_id" label="id"></el-table-column>
        <el-table-column prop="nums" label="人数"></el-table-column>
        <!-- <el-table-column prop="content" width="600" label="文案"></el-table-column> -->
        <el-table-column prop="created_at" label="发送时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button size="small" type="primary" @click="toDetails(row.batch_id)">详情</el-button>
            <el-button size="small" type="danger" @click="handleDelete(row.batch_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta ? dataMeta.per_page : 20" :total="dataMeta ? dataMeta.total : 0"
        :current-page="page" @current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page">
      </el-pagination>
    </div>
    <!-- 弹窗 -->
    <!-- 发布站内信弹窗 -->
    <MailDialog :visible="visibleAdd" @close="visibleAdd = false"></MailDialog>
  </div>
</template>

<script>
import {
  server,
  delData,
  getData,
  patchData,
  postData,
  getApiData,
  patchApiData
} from '@/http'
import {
  getCookie
} from '@/utils/cookie'
import MessageDetail from './MessageDetail'
import MailDialog from './components/MailDialog.vue'

export default {
  components: {
    MessageDetail,
    MailDialog
  },
  data() {
    return {
      visibleAdd: false, //发送站内信弹窗
      loading: false,
      query: {
        page: 1,
        content: undefined
      },
      dataList: undefined,
      dataMeta: undefined,
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}send_news_export`
    }
  },
  created() {
    this.getData(1)
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      getApiData('news_list', {
        ...this.query
      })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    toDetails(id) {
      // 去详情页面
      let routeData = this.$router.resolve({
        path: `/system_mail_detail/${id}`
      })
      window.open(routeData.href, '_blank')
    },
    handleDelete(id) {
      //删除
      this.$confirm('确认删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delData(`news_batch_del/${id}`).then(
          () => {
            this.$message.success('删除成功')
            this.getData()
          }
        )
      }).catch(() => { })
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
      this.getData()
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    downloadExcel() {
      //下载excel模版
      window.open('./excel/站内消息.xlsx', '_blank')
    },
  },
}

</script>
